import {forwardRef, Ref, useImperativeHandle, useState, useEffect} from 'react';

import loaderImg from '../../assets/loading_icon.png';

import './Loader.scss'

interface ILoader {
    show?: boolean;
    src?: string | null;
}

export interface ILoaderRef {
    showLoader: (value: boolean) => void;
}

const Loader = forwardRef((props: ILoader, ref: Ref<ILoaderRef>) => {

    useImperativeHandle(ref, () => ({showLoader}));

    function showLoader(value: boolean): void {
        setShow(value)
    }

    const [show, setShow] = useState(props.show);

    useEffect(() => {
        if (show !== undefined) {
            setShow(show)
        }
    }, [show])

    return (
        <div className="loading_wheel_container"
             style={{visibility: show ? 'visible' : 'hidden'}}
        >
            <img src={props.src ? props.src : loaderImg} alt={"No found image"}/>
        </div>
    )
})

export default Loader;
